import React from 'react';
const SvgFeedback = ({ title, ...props }) => (
    <svg viewBox="0 0 390 390" {...props}>
        {title ? <title>{title}</title> : null}
        <path
            d="M314.9 95.8c22.1 0 40 17.9 40 40v118.4c0 22.1-17.9 40-40 40h-39l.7 35.7c0 2.3.4 11.4 3 23.2-8.7-.9-16.7-2.3-23.9-4.4-18.8-5.4-29.7-15.1-37.6-33.5l-9.1-21.1H75c-22.1 0-40-17.9-40-40V135.7c0-22.1 17.9-40 40-40h239.9m0-34.9H75c-41.4 0-75 33.6-75 75v118.4c0 41.4 33.6 75 75 75h110.9c26.3 60.7 82.2 60.8 154.2 60.8h.5c-28.2-18.2-29.1-60.8-29.1-60.8h3.3c41.4 0 75-33.6 75-75V135.8c0-41.4-33.6-75-75-75z"
            fill="#fff"
        />
    </svg>
);
export default SvgFeedback;